var messages = [
  'Veuillez toujours clôturer direct après un transport.',
  'Un transport a été modifié.',
  'Un transport est annulé.',
]
export default {

  methods: {
    notify(item, options) {
      var app = this;
      app.$refs.notifyBooking.open(item, options).then((data) => {
        console.log('notify send: ', data);

        if (data) {
          app.$http
            .post('service/notification/sendBooking', data)
            // .post('service/notification/message', {msg: data.msg, driverId: data.booking.driverId})
            .then(response => {
              console.log('notification sended', response);
            })
            .catch(function (error) {
              console.log('notification catch:', error);
            });
        }

      })
    },
    notifyChange(booking, type) {
      var app = this;
      console.log('notifyChange', booking);
      var msg = type ? messages[type] : messages[0];
      var name = (booking.driver_lastname + ' ' +  booking.driver_firstname);
      var item = {msg: msg, driverId: booking.driverId, name}
      app.$refs.notifyMessage.open(item).then((data) => {
        // console.log('notify send: ', data);
        if (data) {
          app.$http
            .post('service/notification/message', data)
            .then(response => {
              console.log('notification sended', response);
            })
            .catch(function (error) {
              console.log('notification catch:', error);
            });
        }
      })
    }
  }
}
